import React from 'react'
import { Box } from '@containous/faency'

export const NotFound: React.FC = () => <Box>NotFound</Box>
